import * as React from 'react';

import Description from './Description';
import EmailList from './EmailList';
import NotificationTimeSettings from './NotificationTimeSettings';

const NotificationSettingsForms: React.FC = () => {

	return (
		<div className="form-box">
			<Description />
			<NotificationTimeSettings />
			<EmailList />
		</div>
	);
};

export default React.memo(NotificationSettingsForms);
